import React from 'react';
import classnames from 'classnames';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import TextRenderer from '../../../../TextRenderer';
import { LongStatusViewer } from '../../../../DaEditorWrapper/Viewer/Status';
import draftTheme from '../../../../DaEditorWrapper/Themes/Viewer/feedcard.scss';
import legacyTheme from '../../feedcard.legacy.theme.scss';
import s from './LongStatus.scss';
var LongStatusFeedCardContents = function (_a) {
    var deviation = _a.deviation;
    var tier = useSubscriptionTier(deviation).tier;
    return (React.createElement(React.Fragment, null,
        !!tier && React.createElement(PromoBadge, { badgeType: "tier", size: 40, className: s['tier-badge'] }),
        React.createElement(TextRenderer, { textContent: deviation.textContent, reactViewer: LongStatusViewer, viewerKey: deviation.deviationId, legacyTheme: "status", fixedParagraph: false, disableLazyLoading: true, draftjsThemeOverride: draftTheme, className: classnames(s['content'], legacyTheme['legacy'], legacyTheme['override'], draftTheme['override']) })));
};
LongStatusFeedCardContents.displayName = 'LongStatusFeedCardContents';
export default LongStatusFeedCardContents;
//# sourceMappingURL=LongStatus.js.map